module.exports = __webpack_public_path__ + "static/science-7c-85dda10eff61ec4c7c220bbcabd82ef3.png";